import { FC } from 'react';

type FileUploadStatusMessageProps = {
  message: string;
};

export const FileUploadStatusMessage: FC<FileUploadStatusMessageProps> = ({ message }) => {
  return <p className='text-sm text-gray-900'>{message}</p>;
};
